export enum EScaleOption {
  FIT_SCREEN = 'FIT_SCREEN',
  FULL_SIZE = 'FULL_SIZE',
}

export const DEFAULT_SCALE_OPTION: EScaleOption = EScaleOption.FULL_SIZE;
